/**
 * Maps Norwegian traffic law names to their official public URLs.
 * Sources are all publicly available from Lovdata and Statens vegvesen.
 */
export const LAW_SOURCES = [
  {
    pattern: /Vegtrafikkloven/i,
    name: "Vegtrafikkloven",
    url: "https://lovdata.no/dokument/NL/lov/1965-06-18-4",
    label: "Vegtrafikkloven (Road Traffic Act)",
  },
  {
    pattern: /Trafikkreglene/i,
    name: "Trafikkreglene",
    url: "https://lovdata.no/dokument/SF/forskrift/1986-03-21-747",
    label: "Trafikkreglene (Traffic Rules Regulation)",
  },
  {
    pattern: /Skiltforskriften/i,
    name: "Skiltforskriften",
    url: "https://lovdata.no/dokument/SF/forskrift/2005-10-07-1219",
    label: "Skiltforskriften (Traffic Signs Regulation)",
  },
  {
    pattern: /Læreplan V851/i,
    name: "Læreplan V851",
    url: "https://www.vegvesen.no/globalassets/fag/handboker/hb-v851.pdf",
    label: "Læreplan V851 (Driving Curriculum)",
  },
  {
    pattern: /Forskrift om bruk av kjøretøy/i,
    name: "Forskrift om bruk av kjøretøy",
    url: "https://lovdata.no/dokument/SF/forskrift/1994-10-25-927",
    label: "Forskrift om bruk av kjøretøy",
  },
  {
    pattern: /Førerkortforskriften|Forskrift om førerkort/i,
    name: "Førerkortforskriften",
    url: "https://lovdata.no/dokument/SF/forskrift/2004-01-19-298",
    label: "Førerkortforskriften (Driving Licence Regulation)",
  },
  {
    pattern: /Bilansvarsloven/i,
    name: "Bilansvarsloven",
    url: "https://lovdata.no/dokument/NL/lov/1961-02-03-4",
    label: "Bilansvarsloven (Motor Vehicle Liability Act)",
  },
  {
    pattern: /Forskrift om forbud mot (?:bruk av )?mobiltelefon/i,
    name: "Mobiltelefon-forskriften",
    url: "https://lovdata.no/dokument/SF/forskrift/1999-12-21-1565",
    label: "Forskrift om forbud mot mobilbruk under kjøring",
  },
  {
    pattern: /Forskrift om bruk av personlig verneutstyr/i,
    name: "Verneutstyr-forskriften",
    url: "https://lovdata.no/dokument/SF/forskrift/1979-09-21-7",
    label: "Forskrift om bruk av personlig verneutstyr",
  },
  {
    pattern: /Statens vegvesen/i,
    name: "Statens vegvesen",
    url: "https://www.vegvesen.no/forerkort/ta-forerkort/teoriprove/",
    label: "Statens vegvesen – Theory test info",
  },
];

/**
 * Given a reference string, returns an array of { text, url, label } segments.
 * Text-only segments have url = null.
 *
 * Example:
 *   parseReference("Trafikkreglene §13 — speed limits")
 *   → [{ text: "Trafikkreglene §13 — speed limits", url: "https://lovdata.no/...", label: "Trafikkreglene" }]
 */
export function parseReference(reference) {
  if (!reference) return [];

  // Find the first matching law source
  for (const source of LAW_SOURCES) {
    if (source.pattern.test(reference)) {
      return [{ text: reference, url: source.url, label: source.label }];
    }
  }

  // No match — return as plain text
  return [{ text: reference, url: null, label: null }];
}
